import { supabase } from '@/integrations/supabase/client';
import { uploadProductImage } from '@/lib/uploadImage';

/**
 * Create new retailer
 */
export async function createRetailer(data: {
  name: string;
  slug: string;
  description?: string;
  logo_url?: string;
  affiliate_base_url?: string;
}) {
  const { error } = await supabase.from('retailers').insert({
    name: data.name,
    slug: data.slug,
    description: data.description || null,
    logo_url: data.logo_url || null,
    affiliate_base_url: data.affiliate_base_url || null,
  });

  if (error) throw error;
}

/**
 * Update existing retailer
 */
export async function updateRetailer(
  id: string,
  updates: {
    name?: string;
    description?: string;
    logo_url?: string;
    affiliate_base_url?: string;
    is_active?: boolean;
  }
) {
  const { error } = await supabase
    .from('retailers')
    .update({
      ...updates,
      updated_at: new Date().toISOString(),
    })
    .eq('id', id);

  if (error) throw error;
}

/**
 * Delete retailer
 */
export async function deleteRetailer(id: string): Promise<void> {
  const { error } = await supabase.from('retailers').delete().eq('id', id);

  if (error) throw error;
}

/**
 * Upload retailer logo to storage
 */
export async function uploadRetailerLogo(file: File): Promise<string> {
  const result = await uploadProductImage(file, 'products');
  return result.url;
}
